import type React from "react"
import { useState } from "react"

import { Icon } from "semantic-ui-react"
import { styled } from "styled-components"

const GiphyOverlay = styled.div`
  display: inline-block;

  max-width: 200px;
  height: 150px;
  max-height: 150px;

  overflow: hidden;
  position: relative;
  margin: 0 3px;
  img {
    display: block;
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
  .delete-icon {
    position: absolute;
    top: 0px;
    right: 0px;
  }
`

type GiphyGifProps = {
  gif: any
  size: string
  onClickGif?: () => void
  canDelete?: boolean
  style?: React.CSSProperties
}

const getSizedUrl = (gif, size) => {
  switch (size) {
    case "fixed_small":
      return gif.images.fixed_width_small.url
    case "fixed":
      return gif.images.fixed_width.url
    default:
      return gif.images.fixed_width.url
  }
}

export const GiphyGif = ({ gif, size, onClickGif, canDelete, style }: GiphyGifProps) => {
  const [imageHover, setHovered] = useState(false)
  /*
      Ensure you provide the size prop - This ensures the component can pick a valid URL from the gif data
    */
  const gifUrl = !size ? gif.url : getSizedUrl(gif, size)
  return (
    <GiphyOverlay
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClickGif}
      className={canDelete ? "giphy-overlay" : null}
    >
      <img
        style={{
          cursor: onClickGif ? "pointer" : null,
          borderRadius: 5,
          ...(style || {}),
        }}
        src={gifUrl}
        alt={gif.title || "Gif"}
      />
      {imageHover && canDelete && <Icon inverted circular name="close" className="delete-icon" />}
    </GiphyOverlay>
  )
}
